import { FileTextOutlineIcon } from '@carboncopyco/icons';
import { Button, ColorHex, Paper, TextButton } from '@carboncopyco/ui';
import type { Article } from './types';

type ArticleCardProps = Article;

export const ArticleCard = ({
  title,
  illustration,
  href,
}: ArticleCardProps) => {
  return (
    <Paper
      radius
      border="ds-regular"
      padding="sm"
    >
      <div className="flex gap-5 items-center">
        <div className="shrink-0">{illustration}</div>
        <div className="flex flex-col items-start gap-1">
          <TextButton
            label={title}
            color="text-ds-natural-600"
          />
          <Button
            xSmall
            linkLight
            leftIcon={<FileTextOutlineIcon color={ColorHex.natural300} />}
            label="Read more"
            textColor="text-ds-natural-300"
            onClick={() => {
              window.open(href, '_blank');
            }}
          />
        </div>
      </div>
    </Paper>
  );
};
